import { EditOutlined, GithubOutlined, GoogleOutlined, MailOutlined } from "@ant-design/icons";
import { Avatar, Button, Divider, Flex, Input, Typography, message } from "antd";
import { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  updateDoc,
  serverTimestamp
} from "firebase/firestore";
import { auth, db, db_fire, githubProvider } from "../firebase";
import axios from "../axios";
import { setUser } from "../redux/slice/user";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginWithGoogle } from "../firebase/googleLogin";
import { loginWithGithub } from "../firebase/githubLogin";
import Loading from "../components/Loading"
import { getRedirectResult } from "firebase/auth";
import { getDeviceInfo, getUserIP } from "../utils/location";
import moment from "moment/moment";


const { Title, Text } = Typography;

export default function Email() {
  const [step, setStep] = useState(1); // 1 = email, 2 = otp
  const { location } = useSelector(state => state.local)
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [constOtp, setConstOtp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    const handleGithubRedirect = async () => {
      try {
        const result = await getRedirectResult(auth);

        if (result?.user && result.providerId === "github.com") {
          console.log("GitHub Redirect User 👉", result.user);

          // ✅ Call your Firestore + Redux handler
          handleLoginUser(
            result.user.displayName || result.user.email,
            result.user.email,
            result.user.phoneNumber || "",
            result.user.photoURL,
            "github"
          );
        }
      } catch (err) {
        console.error("GitHub redirect error 👉", err);
      }
    };

    handleGithubRedirect();
  }, []);

  useEffect(() => {
    const handleGoogleRedirect = async () => {
      try {
        const result = await getRedirectResult(auth);

        if (result?.user) {
          console.log("Google Redirect User 👉", result.user);

          // ✅ Call your Firestore + Redux login handler
          handleLoginUser(
            result.user.displayName,
            result.user.email,
            result.user.phoneNumber,
            result.user.photoURL,
            "google"
          );
        }
      } catch (err) {
        console.error("Redirect login error 👉", err);
      }
    };

    handleGoogleRedirect();
  }, []);


  const generateOTP = () =>
    Math.floor(1000 + Math.random() * 9000).toString();

  // 📤 Send OTP
  const sendOTP = async () => {
    if (!email) return message.warning("Enter email");

    const newOtp = generateOTP(); // ✅ generate locally

    setLoading(true);
    setConstOtp(newOtp);

    try {
      await axios.post("/send-otp", { to: email, otp: newOtp });

      message.success("OTP sent successfully");
      setStep(2);
      startTimer();
      startExpireOtpTimer();
    } catch (err) {
      message.error(err.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };


  // ⏱ Countdown timer
  const startTimer = () => {
    setTimer(15);

    const interval = setInterval(() => {
      setTimer((t) => {
        if (t <= 1) {
          clearInterval(interval);
          return 0;
        }
        return t - 1;
      });
    }, 1000);
  };


  const startExpireOtpTimer = () => {
    setTimeout(() => {
      setConstOtp(null);
    }, 300000);
  };


  // 🔁 Resend OTP
  const resendOTP = () => {
    sendOTP()
    setOtp("")
  };

  // ✅ Verify OTP
  const verifyOTP = async () => {
    if (otp.length !== 4) {
      return message.warning("Enter 4 digit OTP");
    }

    if (!constOtp) {
      return message.error("Expired OTP");
    }

    if (otp !== constOtp) {
      return message.error("Invalid OTP");
    }
    handleLoginUser(
      email.split("@")[0].toUpperCase(),
      email, "", "",
      "guest")


  };


  const handleLoginUser = async (
    user_name,
    user_email = "",
    user_phone = "",
    user_photo = "",
    user_login_method = "guest"
  ) => {
    setLoading(true);

    try {
      const usersRef = collection(db_fire, "users");

      // 🔍 Find user by email
      const q = query(usersRef
        , where("email", "==", user_email)
      );
      const querySnapshot = await getDocs(q);



      let userData = null;
      let userDocId = null;

      if (!querySnapshot.empty) {
        const isAdmin = querySnapshot.docs.some(d => d.data().admin === true);
        if (!isAdmin) {
          message.error("Admin login only");
          setOtp("")
          return
        }
        // ✅ USER EXISTS → READ FULL DATA
        const docSnap = querySnapshot.docs[0];
        userDocId = docSnap.id;

        // 🔁 Update last login
        await updateDoc(docSnap.ref, {
          lastLogin: serverTimestamp(),
        });

        // ✅ Use DB data (IMPORTANT)
        userData = {
          _id: userDocId,
          ...docSnap.data(),
        };

        // ✅ SINGLE SOURCE OF TRUTH → FIRESTORE
        dispatch(setUser(userData));
        message.success("Login successful");
        navigate("/", { replace: true });

      }

      var user_device = getDeviceInfo() || "Unknown";
      var user_ip = await getUserIP() || "Unknown";
      if (userData?.email) {
        var end_point_api = querySnapshot.empty ? "/send-welcome-mail" : "/send-login-mail"
        await axios.post(end_point_api, {
          to: userData?.email,
          name: userData?.name,
          device: user_device,
          location: location.address,
          ip: user_ip,
          time: moment(Date.now()).format("llll")
        });
      }

    } catch (err) {
      console.error("LOGIN ERROR 👉", err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };



  const handleGithubLogin = async () => {
    try {
      setLoading(true)
      const user = await loginWithGithub();

      handleLoginUser(
        user.displayName,
        user.email,
        user.phoneNumber,
        user.photoURL,
        "Github")

      console.log(user);
    } catch (err) {
      console.error("GitHub Error 👉", err);
      message.error(err.code || err.message);
    } finally {
      setLoading(false)
    }
  };


  const handleGoogleLogin = async () => {
    try {
      setLoading(true)
      const user = await loginWithGoogle();
      handleLoginUser(
        user.displayName,
        user.email,
        user.phoneNumber,
        user.photoURL,
        "Google")

    } catch (err) {
      console.error("Google Login Error 👉", err);
      message.error(err.code || err.message);
    } finally {
      setLoading(false)
    }
  };


  return (
    <>
      {loading && <Loading />}
      <div
        style={{
          maxWidth: 360,
          margin: "auto",
          padding: 24,
          border: "1px solid #f0f0f0",
          borderRadius: 12
        }}
      > <br /><br />

        <Flex justify="center">
          <img width={100} src="/image/logo_trans.png" />
        </Flex>

        <Title level={4} style={{ textAlign: "center", margin: "20px 0" }}>
          Admin Login
        </Title>

        {/* STEP 1 */}
        {step === 1 && (
          <Flex vertical style={{ width: "100%" }} gap={15}>
            <Input
              prefix={<MailOutlined />}
              type="email"
              placeholder="Enter email address"
              value={email}
              onKeyUp={e => e.key === "Enter" && sendOTP()}
              onChange={(e) =>
                setEmail(e.target.value.toLowerCase())
              }
            />
            <Button
              type="primary"
              block
              onClick={sendOTP}
            >
              Send OTP
            </Button>
          </Flex>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <Flex vertical style={{ width: "100%" }} gap={15}>
            <Text>
              OTP sent to <b> {email}</b> <Button type="link" size="small"><EditOutlined onClick={_ => setStep(1)} /></Button>
            </Text>

            <Input.OTP
              length={4}
              value={otp}
              type="number"
              style={{ margin: "auto" }}
              onChange={setOtp}
              onKeyUp={_ => otp.length == 4 && verifyOTP()}
              autoFocus
            />

            <Button
              type="primary"
              block
              onClick={verifyOTP}
            >
              Verify OTP
            </Button>

            <Button
              type="link"
              disabled={timer > 0}
              onClick={resendOTP}
            >
              {timer > 0 ? `Resend OTP in ${timer}s` : "Resend OTP"}
            </Button>
          </Flex>
        )}

        <Divider plain>or</Divider>

        <Flex gap={15}>
          <Button block onClick={handleGoogleLogin}><GoogleOutlined /></Button>
          <Button onClick={handleGithubLogin} block><GithubOutlined /></Button>
        </Flex> <br />

        <Flex gap={10} justify="center" style={{ fontSize: "15px" }}>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <big>•</big>
          <Link to="/terms-and-conditions">Term and Conditions</Link>
        </Flex>

      </div>
    </>
  );
}
